<template>
    <div class="select-product">
        <el-dialog title="添加" :visible.sync="dialogVisible" width="768px" :before-close="close">
            <div class="form">
                <el-form :model="formInline" ref="formInline" :rules="rules" class="demo-form-inline" label-position="left" label-width="100px">
                    <el-form-item label="监控类型：">
                        <p>商品价格</p>
                    </el-form-item>
                    <el-form-item label="品牌名称：" prop="brand_id">
                        <el-select v-model="formInline.brand_id" placeholder="请选择品牌名称" style="width: 400px">
                            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品名称：" prop="name">
                        <el-input v-model="formInline.name" placeholder="请输入商品名称" clearable style="width: 400px"></el-input>
                    </el-form-item>
                    <el-form-item label="规格型号：" prop="spec_name">
                        <el-input v-model="formInline.spec_name" placeholder="请输入规格型号" clearable style="width: 400px"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close" size="medium">取 消</el-button>
                <el-button type="primary" @click="submit" size="medium" :loading="createLoad">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            createLoad: false,
            dialogVisible: false,
            formInline: {
                brand_id: "",
                name: "",
                spec_name: "",
            },
            rules: {
                brand_id: [{ required: true, message: "请选择品牌名称", trigger: "change" }],
                name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
                spec_name: [{ required: true, message: "请输入规格型号", trigger: "blur" }],
            },
            editId: 0,
        };
    },

    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {},
    props: {
        options: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    methods: {
        ...mapActions({
            createCompeteProduct: "brand/createCompeteProduct",
            editCompeteProduct: "brand/editCompeteProduct",
        }),
        close() {
            this.$refs.formInline.resetFields();
            this.formInline = {
                brand_id: "",
                name: "",
                spec_name: "",
            };
            this.dialogVisible = false;
        },
        // 添加/编辑商品
        submit() {
            this.$refs.formInline.validate((valid) => {
                if (valid) {
                    this.createLoad = true;
                    let params = {
                        token: this.getToken,
                        brand_id: this.formInline.brand_id,
                        name: this.formInline.name,
                        spec_name: this.formInline.spec_name,
                    };
                    let url;
                    if (this.editId != 0) {
                        params.id = this.editId;
                        url = this.editCompeteProduct;
                    } else {
                        url = this.createCompeteProduct;
                    }
                    url(params).then(({ data }) => {
                        this.createLoad = false;
                        if (data.code == 1) {
                            this.$message.success(`${this.editId == 0 ? "添加成功" : "修改成功"}！`);
                            this.formInline = {};
                            this.dialogVisible = false;
                            this.$emit("init");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.select-product {
    ::v-deep .has-gutter tr th {
        background-color: rgb(217, 236, 255) !important;
    }
    .pageList {
        text-align: right;
        margin-top: 20px;
    }
}
.link {
    a {
        margin: 0 8px;
    }
}
.el-table {
    height: 350px;
    overflow-y: auto;
}
</style>